import {
  GetEventsByMiniHotelResponse,
  GetEventsByMiniHotelDttResponse,
  getEventsByMiniHotelDttQuery,
  getEventsByMiniHotelQuery,
} from '@marriott/mi-groups-graphql';
import { useLazyQueryTransformer } from '../../../hooks';

type RoomingListEventsByMiniHotel = {
  groupsRoomingListEventsByMiniHotel: GetEventsByMiniHotelResponse;
};

type RoomingListEventsByMiniHotelDtt = {
  hotelOperations: GetEventsByMiniHotelDttResponse;
};

const dttResponse: RoomingListEventsByMiniHotelDtt = {
  hotelOperations: {
    groupManagement: {
      roomingListEventsByGroupCode: {
        roomingListEvents: [
          {
            id: '',
            title: '',
            groupEventSummary: {
              arrive: '',
              depart: '',
            },
            plannerDetails: [
              {
                id: '',
                lastName: '',
              },
            ],
          },
        ],
        errors: [],
      },
    },
  },
};

export const useGetEventsByMiniHotel = () => {
  return useLazyQueryTransformer<RoomingListEventsByMiniHotel, RoomingListEventsByMiniHotelDtt>({
    currentQuery: getEventsByMiniHotelQuery,
    dttQuery: getEventsByMiniHotelDttQuery,
    onTransform: data => {
      const { eventDetails, messages } = data?.groupsRoomingListEventsByMiniHotel || {};

      dttResponse.hotelOperations.groupManagement.roomingListEventsByGroupCode.roomingListEvents = eventDetails?.map(
        event => ({
          id: event.roomingListEvent?.id,
          title: event.title,
          groupEventSummary: {
            arrive: event.startDate,
            depart: event.endDate,
          },
          plannerDetails: event.roomingListEvent?.plannerDetails,
        })
      );

      dttResponse.hotelOperations.groupManagement.roomingListEventsByGroupCode.errors =
        messages?.map(errors => ({
          message: errors.dev?.message,
        })) || [];

      return dttResponse;
    },
  });
};
